<template>
  <ais-refinement-list
    :attribute="filter.id"
    :transformItems="transformItems"
    :limit="999"
    :sort-by="['name:asc']"
    operator="and"
  >
    <template v-slot="{ items, refine }">
      <div class="finish-filter">
        <div class="filter-values">
          <span
            v-for="item in items"
            :key="item.value"
            class="filter-value"
            :class="{
              [`filter-value-${getFinishClassName(item.value)}`]: true,
              active: item.isRefined,
            }"
            @click="handleClick(refine, item)"
          >
            {{ item.label }}
          </span>
        </div>
      </div>
    </template>
  </ais-refinement-list>
</template>

<script>
import {transformItems, scrollToTopAfterFilterChange} from '../filters-config';
import {getFinishClassName} from '../finish-translations';

export default {
  props: {
    filter: {type: Object, required: true}
  },
  methods: {
    getFinishClassName,
    transformItems(items) {
      return transformItems(this.filter, items);
    },
    handleClick(refine, item) {
      refine(item.value);
      scrollToTopAfterFilterChange();
    }
  }
};
</script>
